import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'

import productos from './productos'
import tipos from './tipos'
import subtipos from './subtipos'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'mtmultityping',
    ...crudState()
  }),
  getters: {
    ...crudGetters
  },
  mutations: {
    ...crudMutations
  },
  actions: {
    ...crudActions
  },
  modules: {
    productos,
    tipos,
    subtipos
  }
}
